module.exports = __webpack_public_path__ + "static/media/img_museum.032df9d4.png";